import React from "react";
import styles from "./progressSetup.module.css"
import Button from "../../../../components/Form/Button";
import { MdBuild, MdOutlineCheck } from "react-icons/md";

const ProgressSetup = ({ step = 0, totalSteps = 4, showProgress = true, stepLabel, title, description, btnText, btnAltText, onClick = () => { }, onClickAlt = () => { }, children }) => {
    const getProgressBar = (step) => {
        const progressList = Array.from({ length: totalSteps }, (_, index) => index + 1)
        return (
            <div className={styles.progressBar}>
                {progressList.map((el, index) => (
                    <div className={`${styles.groupStep} ${el < step ? styles.finish : (el === step ? styles.setting : '')}`} key={index}>
                        {el > 1 && <div className={styles.connector}></div>}
                        <div className={styles.step}>{el < step ? <MdOutlineCheck /> : (el === step ? <MdBuild /> : '')}</div>
                        {el < progressList.length && <div className={styles.connector}></div>}
                    </div>
                ))}
            </div>
        )
    }

    return (
        <div className={styles.progressSetup}>
            {showProgress && getProgressBar(step)}
            <div className={styles.text}>
                <span className={styles.stepMeta}>{stepLabel || (step === totalSteps ? "Finalização" : `Etapa ${step} de ${totalSteps}`)}</span>
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.description}>{description}</p>
            </div>
            {children && <div className={styles.content}>{children}</div>}
            <div className={styles.button}>
                <Button variant="primary" onClick={onClick}>{btnText}</Button>
                {btnAltText && <Button variant="secondary" onClick={onClickAlt}>{btnAltText}</Button>}
            </div>
        </div>
    )
}

export default ProgressSetup
